module.exports = __webpack_public_path__ + "assets/img/Exchange_tit.43271988.png";